/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import React, { useCallback } from "react";
import { PageContentNonMemoized } from "gatsby-plugin-hfn-profile/components/PageContentNonMemoized";
import LayoutHome from "../layout/LayoutHome";
import { eventCallbackTriggers } from "../templates/wppage";

const ShriRamChandraMissionUSA = () => {
  const pageContent = (id, modalTitle) => {
    const titletext = modalTitle || "Heartfulness Donation SRCM, USA";
    return `<gatsby_donation donationId = ${id} btntext = "${titletext}" btnBg = #4d8f15 colortext = black colorprimary = forestgreen colorsecondary = darkgreen colorbackground = white colormuted = #f6f6f6 colorhighlight = #efeffe titletext = "Shri Ram Chandra Mission, USA" />`;
  };

  const PageContent = React.memo(PageContentNonMemoized);

  const eventCallback = useCallback(
    (event) => eventCallbackTriggers("Shri_Ram_Chandra_Mission,_USA", event),
    []
  );

  return (
    <LayoutHome
      seoTitle="Shri Ram Chandra Mission USA -Donations"
      contentHeaderStyle="contentHeaderText"
      contentHeader={<h3>Shri Ram Chandra Mission USA</h3>}
    >
      <React.Fragment>
        <p sx={{ my: 3, fontSize: "24px" }}>
          Voluntary Donation – Options to donate
        </p>
        <Box
          sx={{ backgroundColor: "#e9f6f9", padding: "15px", margin: "20px 0" }}
        >
          <h4
            sx={{
              borderBottom: "solid 1px #c9dfe4",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
          >
            ACH & Wire Transfer
          </h4>
          <p>
            Business Name: Shri Ram Chandra Mission
            <br />
            Business Address: PO Box 3413 Princeton, NJ 08543-3413
            <br />
            Bank Name & AC: Chase Bank (Checking Account)
            <br />
            Account number: 692 282 992
            <br />
            Routing number: 021202337 (ACH) ; 021000021 (Wire)
          </p>
        </Box>
        <Box
          sx={{ backgroundColor: "#e9f6f9", padding: "15px", margin: "20px 0" }}
        >
          <h4
            sx={{
              borderBottom: "solid 1px #c9dfe4",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
          >
            Checks
          </h4>
          <small>
            Checks should be payable to &quot;Shri Ram Chandra Mission&quot; and
            mailing it to the following address:
          </small>
          <p>
            Shri Ram Chandra Mission
            <br />P O BOX 3413
            <br />
            Princeton NJ 08543
          </p>
        </Box>
        <Box
          sx={{ backgroundColor: "#e9f6f9", padding: "15px", margin: "20px 0" }}
        >
          <h4
            sx={{
              borderBottom: "solid 1px #c9dfe4",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
          >
            Stock Donations
          </h4>
          <small>
            Please send stock to Shri Ram Chandra Mission’s account at Merrill
            Lynch. DTC and Account info is as follows:
          </small>
          <p>
            Title: Shri Ram Chandra Mission
            <br />
            Account No.: 876-04508
            <br />
            Receiving Firm: Merrill Lynch Wealth Management
            <br />
            DTC#: 8862/0671
          </p>
          <br />
        </Box>
        <Box
          sx={{ backgroundColor: "#f2fafc", padding: "15px", margin: "20px 0" }}
        >
          <h4
            sx={{
              borderBottom: "solid 1px #c9dfe4",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
          >
            Notify SRCM of Gift
          </h4>
          <small>
            For SRCM to identify your gift and send a tax receipt, kindly send
            an email to &nbsp;
            <a href="mailto:us.treasurer@srcm.org">us.treasurer@srcm.org</a> and
            &nbsp;<a href="mailto:us.accounts@srcm.org">us.accounts@srcm.org</a>{" "}
            with the gift details requested below:
          </small>
          <p>
            Full name of donor:
            <br />
            Email of donor:
            <br />
            Telephone of donor:
            <br />
            Date of transfer:
            <br />
            Name of security:
            <br />
            Number of shares transferred:
          </p>
        </Box>
        <Box
          sx={{ backgroundColor: "#f2fafc", padding: "15px", margin: "20px 0" }}
        >
          <h4
            sx={{
              borderBottom: "solid 1px #c9dfe4",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
          >
            Online Donations (Credit Card)
          </h4>
          <div sx={{ width: "165px" }}>
            <PageContent
              eventCallback={eventCallback}
              pageContent={pageContent(15, "Donate Now")}
            />
          </div>
        </Box>
        {/* <Box
          sx={{ backgroundColor: "#f2fafc", padding: "15px", margin: "20px 0" }}
        >
          <h4
            sx={{
              borderBottom: "solid 1px #c9dfe4",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
          >
            STOCK TRANSFER TO SRCM
          </h4>
          <small>
            Instruct institution where securities are held to transfer the
            shares to Shri Ram Chandra Mission&apos;s account at Merrill Lynch,
            DTC and Account Numbers are as follows:
          </small>
          <p>
            Account No.: 8UN-02004
            <br />
            Title: Shri Ram Chandra Mission
            <br />
            Receiving Firm: Merrill Lynch
            <br />
            DTC#: 8862
          </p>
        </Box> */}
        {/* <Box
          sx={{ backgroundColor: "#e9f6f9", padding: "15px", margin: "20px 0" }}
        >
          <h4
            sx={{
              borderBottom: "solid 1px #c9dfe4",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
          >
            Notify SRCM of Gift
          </h4>
          <small>
            SRCM to identify your gift and send a tax receipt you will need to
            email{" "}
            <a href="mailto:us.treasurer@srcm.org">us.treasurer@srcm.org</a>{" "}
            with the gift details requested below
          </small>
          <p>
            Full name of donor:
            <br />
            Email of donor:
            <br />
            Telephone of donor:
            <br />
            Date of transfer:
            <br />
            Name of security:
            <br />
            Number of shares transferred:
          </p>
        </Box> */}
        <small>
          For any inquiries or requests for information, please contact us via
          email at{" "}
          <a href="mailto:us.treasurer@srcm.org ">us.treasurer@srcm.org </a> and{" "}
          <a href="mailto:us.accounts@srcm.org ">us.accounts@srcm.org </a>
        </small>
      </React.Fragment>
    </LayoutHome>
  );
};

export default ShriRamChandraMissionUSA;
